import { render, staticRenderFns } from "./PpeApplyScrapList.vue?vue&type=template&id=b322255c&"
import script from "./PpeApplyScrapList.vue?vue&type=script&lang=js&"
export * from "./PpeApplyScrapList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports